import store from '@/store'
// import * as filters from './filters'

export function setMetaTitle () {
  let router = store.state.route.meta.title
  document.title = `${router} | IDC Online Cloud`
}

export function numberWithDelimiter (number, delimiter = '.') {
  return Math.round(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimiter)
}

export function hasPermission () {
  const userInfo = store.state.auth.userInfo
  let flag = {
    ok: true,
    msg: this.$t('hasPermission.msg')
  }
  if (userInfo !== null) {
    let err = []
    if (userInfo.is_in_whitelist === true) {
      flag.ok = true
    } else {
      // check verify
      if (!userInfo.email_verified) {
        flag.ok = false
        err.push(this.$t('hasPermission.emailVerified'))
      }

      // check expire trial
      if (userInfo.trial.end_date && userInfo.trial.expired) {
        flag.ok = false
        err.push(this.$t('hasPermission.trialExpired'))
      }

      // check expire invoice
      if (userInfo.has_expired_invoices) {
        flag.ok = false
        err.push(this.$t('hasPermission.hasExpiredInvoices'))
      }
    }
    flag.msg += err.join(', ')
  }
  return flag
}

export function getHoursOfMonth () {
  const date = new Date()
  let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
  lastDay = lastDay.getDate()
  const hoursOfMonth = lastDay * 24
  return hoursOfMonth
}

export function remainingHoursOfMonth () {
  let currentTime = new Date()
  let parseTime = Date.parse(currentTime)
  let lastDayOfMonth = require('moment')().endOf('month').format()
  let parseLastDayOfMonth = Date.parse(lastDayOfMonth)
  let remainingHours = Math.round((parseLastDayOfMonth - parseTime) / 1000 / 60 / 60 + 0.5)
  if (remainingHours === 0) remainingHours = 1
  return remainingHours + 7
}

export function billingInfo (price) {
  const pricing = roundedThousands(price * remainingHoursOfMonth() / getHoursOfMonth())
  return pricing
}

export function roundedThousands (value) {
  if (!value) return 0
  return Math.round((value) / 1000) * 1000
}

const digitsRE = /(\d{3})(?=\d)/g
export function currency (value, currency, decimals) {
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  currency = currency != null ? currency : ''
  decimals = decimals != null ? decimals : 0
  var stringified = Math.abs(value).toFixed(decimals)
  var _int = decimals
    ? stringified.slice(0, -1 - decimals)
    : stringified
  var i = _int.length % 3
  var head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? '.' : ''))
    : ''
  var _float = decimals
    ? stringified.slice(-1 - decimals)
    : ''
  var sign = value < 0 ? '-' : ''
  return sign + currency + head +
    _int.slice(i).replace(digitsRE, '$1.') +
    _float
}



// WEBPACK FOOTER //
// ./src/helper.js